import { useMatomo } from '@datapunt/matomo-tracker-react';
import { MatomoAction, MatomoCategory } from '../../Constants';

/* eslint-disable react/prop-types */
export const ImageUploader = ({ inputFileRef, setSelectedImage }) => {
  const { trackEvent } = useMatomo();

  const onChangeInput = event => {
    if (event?.target?.files?.length) {
      const file = event.target.files[0];

      if (file.size > 5000000) {
        alert('file size cannot exceed 5mb!');
      } else if (!file.type.includes('image')) {
        alert('Not a valid image upload!');
      } else {
        const reader = new FileReader();

        reader.onload = function() {
          localStorage.setItem('customer-logo', reader.result as string);

          trackEvent({
            category: MatomoCategory.Dashboard,
            action: MatomoAction.ImageUpload
          });

          setSelectedImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  return (
    <input
      ref={inputFileRef}
      style={{ display: 'none' }}
      type="file"
      accept=".jpg,.png,.jpeg,.svg,.gif"
      name="logoImage"
      data-testid="logo-image"
      onChange={onChangeInput}
      onClick={(e: any) => (e.target.value = null)}
    />
  );
};
